import { setGeofenceTypes } from '@casops/store/slices/filtersSlice';
import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@casops/filters/types';
import MultiselectFilter from '../multiselect/MultiselectFilter';
import { GeofenceTypeV2 } from '@casops/store/apis/geofencesApi';
import useFenceTypesOptions from '@casops/side-panels/manage-geofence/components/general/useFenceTypeOptions';

export const GeofenceTypesFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();
  return (
    <MultiselectFilter<GeofenceTypeV2>
      filterName="geofenceTypes"
      label={label ?? t('Fields.Filters.GeofenceTypes')}
      action={setGeofenceTypes}
      elementRef={elementRef}
      useItemsHook={useFenceTypesOptions}
    />
  );
};

export default GeofenceTypesFilter;
